import { Grid } from "@material-ui/core";
import { CentreType, PublicEnquiryModel } from "../../domain/PublicEnquiry";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { fieldLabels } from "./fieldLabels";
import { Error } from "../common/Error";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { centreNumberService, countriesService } from "../../services";
import { Select } from "@ofqual/portal-components/components/Select";
import { useState } from "react";

export const CentreArea: React.FC<{
  sectionProps: SectionProps<PublicEnquiryModel>;
}> = ({ sectionProps }) => {
  const { control, errors, disabled } = sectionProps;

  const [centreNumberLookups, countriesLookup] = useLookup(centreNumberService, countriesService);
  const [centerType, setCentreType] = useState<CentreType>();
  const [validationLength, setValidationLength] = useState<
    number | undefined
  >();

  return (
    // <div className={classes.inlineFields}>
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="centreNumberTypeId"
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.centreType}
              data-test="centreNumberType-field"
              readOnly={disabled}
              onChange={(e) => {
                switch (e.target.value) {
                  case CentreType.NCN:
                    setValidationLength(5);
                    setCentreType(CentreType.NCN);
                    break;
                  case CentreType.UKPRN:
                    setValidationLength(8);
                    setCentreType(CentreType.UKPRN);
                    break;
                  default:
                    setCentreType(undefined);
                    setValidationLength(undefined);
                }
                onChange(e.target.value);
              }}
              {...props}
            >
              {centreNumberLookups}
            </Select>
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="centreNumber"
          rules={{
            maxLength: validationLength,
            minLength: validationLength,
            required: centerType !== undefined,
          }}
          as={
            <TextField
              label={fieldLabels.centreNumber}
              data-test="centreNumber-field"
              readOnly={disabled}
              aria-label="Centre Number"
            />
          }
        />
        {errors.centreNumber && validationLength !== undefined && (
          <Error data-test="centre-number-field-error">
            {`Centre number must be ${validationLength} for ${centerType}`}
          </Error>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          name="centreName"
          as={
            <TextField
              label={fieldLabels.centreName}
              data-test="centreName-field"
              readOnly={disabled}
              aria-label="Centre Name"
            />
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="centreAddressLine1"
          as={
            <TextField
              label={fieldLabels.centreAddressLine1}
              data-test="centreAddressLine1-field"
              readOnly={disabled}
              aria-label="Centre Address Line 1"
            />
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="centreAddressLine2"
          as={
            <TextField
              label={fieldLabels.centreAddressLine2}
              data-test="centreAddressLine2-field"
              readOnly={disabled}
              aria-label="Centre Address Line 2"
            />
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="centreTown"
          as={
            <TextField
              label={fieldLabels.centreTown}
              data-test="centreTown-field"
              readOnly={disabled}
              aria-label="Centre City or Town"
            />
          }
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="centrePostCode"
          as={
            <TextField
              label={fieldLabels.centrePostCode}
              data-test="centrePostCode-field"
              readOnly={disabled}
              aria-label="Centre Post Code"
            />
          }
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          name="centreCountry"
          as={
            <Select
              label={fieldLabels.centreCountry}
              data-test="centreCountry-field"
              readOnly={disabled}
              aria-label="Country"
            >
              {countriesLookup}
            </Select>
          }
        />
      </Grid>
    </Grid>
    // </div>
  );
};
